import type { SVGProps } from "react";
export interface PlanetIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlanetIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlanetIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21.395 8.236a10.13 10.13 0 0 1-2.236 10.942 10.13 10.13 0 0 1-10.95 2.23 1.124 1.124 0 0 1 .841-2.087A7.878 7.878 0 0 0 19.307 9.075l2.088-.84ZM19.93 7.61a1.125 1.125 0 0 1 1.464.625l-2.088.839a1.125 1.125 0 0 1 .624-1.464m-7.43.02a.62.62 0 0 0-.124.37l.013.127c.018.09.058.172.111.244v-.74Zm1 .741a.6.6 0 0 0 .113-.244L13.625 8l-.012-.126a.6.6 0 0 0-.112-.245v.741ZM14.627 8a1.626 1.626 0 0 1-3.242.167L11.375 8l.009-.166A1.626 1.626 0 0 1 13 6.375l.165.009c.82.083 1.46.775 1.46 1.616Z"
      />
      <path
        fill={color}
        d="M18.862.99c1.186-.23 2.503-.169 3.41.738.907.906.967 2.223.737 3.41-.239 1.228-.84 2.63-1.686 4.084-1.243 2.132-3.085 4.492-5.347 6.754-2.272 2.272-4.64 4.12-6.78 5.363-1.449.841-2.846 1.437-4.07 1.673-1.183.227-2.495.164-3.399-.74-.877-.877-.96-2.14-.758-3.287.198-1.127.71-2.402 1.438-3.727a10.12 10.12 0 0 1 2.433-10.4l.378-.359A10.13 10.13 0 0 1 15.23 2.422c1.292-.712 2.531-1.218 3.632-1.431ZM3.679 17.785c-.25.6-.414 1.134-.494 1.59-.153.869.028 1.202.133 1.307.11.109.461.299 1.383.122.44-.085.947-.245 1.51-.48a10 10 0 0 1-1.37-1.146 10 10 0 0 1-1.162-1.393M17.569 6.45a7.876 7.876 0 1 0-9.02 12.647c1.822-1.124 3.855-2.73 5.836-4.71 1.972-1.973 3.573-3.996 4.696-5.812a7.9 7.9 0 0 0-1.513-2.125Zm3.112-3.13c-.11-.11-.464-.3-1.39-.12a8 8 0 0 0-1.535.49 10.1 10.1 0 0 1 2.556 2.552c.24-.572.403-1.087.49-1.533.179-.926-.012-1.28-.12-1.39Z"
      />
    </svg>
  );
}
